import { Component, ElementRef, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

const TARIFARIO_DATA: any = [
  { tipo_medidor_instalado: 'Medidor Diafragma G1.6', comentario: 'Contrastes E.I.R.L', costo_prueba: 'S/ 171.91' },
  //{tipo_medidor_instalado: 'Medidor Diafragma G1.6', comentario: 'JOVE CONTRATISTAS Y SERVICIOS GENERALES S.A.C', costo_prueba: 'S/ 170.80'},
  { tipo_medidor_instalado: 'Medidor Diafragma G4', comentario: 'Instituto Nacional de Calidad - INACAL', costo_prueba: 'S/ 366.77' },
];

@Component({
  selector: 'app-meter-recibo-digital',
  templateUrl: './meter-recibo-digital.component.html',
  styleUrls: ['./meter-recibo-digital.component.scss']
})

export class MeterReciboDigitalComponent implements OnInit {

  showConsumo = false;
  showVencimiento = false;
  showEstadistica = false;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {

  }
  ngClickShow(option) {
    switch (option) {
      case 'consumo':
        this.showConsumo = !this.showConsumo;
        break;
      case 'vencimiento':
        this.showVencimiento = !this.showVencimiento;
        break;
      case 'estadistica':
        this.showEstadistica = !this.showEstadistica;
        break;
      default:
        break;
    }
  }



}